module.exports = __webpack_public_path__ + "static/media/customer-support.2c10afb5.png";